module.exports = __webpack_public_path__ + "img/floppy-disk-pen.7ba6557a.svg";